<app-base-current-organization-resellers-statistics
  [title]="title"
  [getMonthlyItemsApiMethodName]="getMonthlyItemsApiMethodName"
  [getDailyItemsApiMethodName]="getDailyItemsApiMethodName"
  [isShowOrganizationDropDown]="false"
  [lineChartId]="lineChartId"
  [barChartId]="barChartId"
  [isShowUserDropDown]="true"
  [isOnlyUserSelect]="true"
  [userType]="userType"
  [isForceSearch]="isForceSearch"
>
</app-base-current-organization-resellers-statistics>
